module.exports = __webpack_public_path__ + "static/Infopfeil-558f863c4f738dea5a3806d19bd9ad1b.svg";